import { css } from 'emotion';

import { colors, fonts, icons } from '../styles';

export const panelWrapper = css`
  display: flex;
  border-radius: 5px;
  padding: 6px 5px 7px 5px;
  box-sizing: border-box;
  justify-content: space-between;
  background-color: ${colors.accessory._5};
`;

export const items = css`
  display: flex;
  align-items: center;
`;

export const contentWrapper = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const iconWrapper = css`
  width: ${icons.size.medium};
  height: ${icons.size.medium};
  color: ${colors.white};
  margin: auto 0 auto 10px;
  align-self: end;
`;

export const infoText = css`
  font-size: ${fonts.size.small};
  font-weight: ${fonts.weight.medium};
  color: ${colors.white};
  margin: 0 15px;
`;

export const actionButton = css`
  && {
    min-width: 150px;
  }
`;

export const closeButton = css`
  width: ${icons.size.largest};
  height: ${icons.size.largest};
`;
